import React, { useEffect, useRef, useState } from "react";
import {
    Button,
    Typography,
    Tabs,
    Dropdown,
    Menu,
    Icon,
    Tooltip,
    Table,
    Col,
    Modal,
    Input,
    DatePicker,
    Select,
    message,
    Row,
} from "antd";

import Loader from "components/Loader/Loader";
import NullImage from "media/placeholder3.png";
import EditorBox from "components/EditorBox/EditorBox";

import {
    createNotificationApi,
    deleteNotificationApi,
    fetchAllStoresApi,
    fetchCohortAdminListApi,
    fetchFlyerListApi,
    fetchNotificationListApi,
    fetchPromotionListApi,
    updateNotificationApi,
} from "utils/apiService";

import moment from "moment";

import emptyImage from "../../media/empty-notifications-img.png";
import { uuid } from "@antv/x6/lib/util/string/uuid";

const { Text } = Typography;
const { TabPane } = Tabs;
const { Option } = Select;

const deepEqual = (object1, object2) => {
    const keys1 = Object.keys(object1);
    const keys2 = Object.keys(object2);

    if (keys1.length !== keys2.length) {
        return false;
    }

    for (const key of keys1) {
        const val1 = object1[key];
        const val2 = object2[key];
        const areObjects = isObject(val1) && isObject(val2);
        if ((areObjects && !deepEqual(val1, val2)) || (!areObjects && val1 !== val2)) {
            return false;
        }
    }

    return true;
};

const isObject = (object) => {
    return object != null && typeof object === "object";
};

const DestinationOption = ({ item }) => {
    // function takes timestamp and returns date time string in dd/mm/yyyy hh:mm AM/PM format using moment
    return (
        <>
            <div>
                <div style={{ display: "flex" }}>
                    <div style={{ width: "40px", marginRight: "12px" }}>
                        <img
                            src={item.outer_image?.url || NullImage}
                            alt='Page Logo'
                            style={{
                                height: "40px",
                                width: "100%",
                                borderRadius: "5px",
                                border: "none",
                            }}
                        />
                    </div>
                    <div style={{ flex: 1 }}>
                        <Text
                            style={{
                                color: "#181818",
                                fontSize: "12px",
                                display: "block",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}>
                            {item.title}
                        </Text>
                        <div>
                            {item.list?.slice(0, 2)?.map((listItem, index) => (
                                <Text
                                    key={index}
                                    style={{
                                        color: "#fec708",
                                        fontSize: "10px",
                                        lineHeight: "14px",
                                        margin: "0px 4px",
                                        background: "#EAF4EC",
                                        padding: "1px 4px",
                                    }}>
                                    {listItem.name}
                                </Text>
                            ))}
                            <Text style={{ color: "#fec708", fontSize: "10px", margin: "0px 4px" }}>
                                {item.list?.length > 2 && `+${item.list.length - 2} More`}
                            </Text>
                        </div>
                    </div>
                </div>
                <Row>
                    <Col span={12} style={{ fontSize: "10px" }}>
                        <Text>Start Date : {moment(item.start_time).format("DD/MM/YYYY")}</Text>
                    </Col>
                    <Col span={12} style={{ fontSize: "10px" }}>
                        <Text>End Date : {moment(item.end_time).format("DD/MM/YYYY")}</Text>
                    </Col>
                </Row>
            </div>
        </>
    );
};

const NotificationCenter = () => {
    const [loading, setLoading] = useState(true);
    const [tableLoading, setTableLoading] = useState(true);

    const [queueList, setQueueList] = useState({
        notificationlist: [],
        pageNum: 1,
        pageSize: 50,
        totalPages: 1,
        total_queue: 0,
    });

    const [sendList, setSendList] = useState({
        notificationlist: [],
        pageNum: 1,
        pageSize: 50,
        totalPages: 1,
        total_sent: 0,
    });

    const [notificationDetail, setNotificationDetail] = useState({
        subject: "",
        description: "",
        cohort_list: [],
        user_list: [],
        schedule_time: null,
        deep_link_type: "",
        deep_link_uuid: "",
        promotion_uuid: "",
        flyer_uuid: "",
    });
    const [notificationDraft, setNotificationDraft] = useState({
        subject: "",
        description: "",
        cohort_list: [],
        user_list: [],
        schedule_time: null,
        deep_link_type: "",
        deep_link_uuid: "",
        promotion_uuid: "",
        flyer_uuid: "",
    });

    const [cohortList, setCohortList] = useState(null);
    const [promotionList, setPromotionList] = useState(null);
    const [flyerList, setFlyerList] = useState(null);
    const [storeList, setStoreList] = useState(null);
    const [selectedstore, setSelectedstore] = useState(null);
    const [notificationDetailsModal, setNotificationDetailsModal] = useState(false);
    const [discardModal, setDiscardModal] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);

    const deleteNotification = useRef("");

    const [activeKey, setActiveKey] = useState("sent");

    const clearNotificationDetail = () => {
        setNotificationDetail({
            subject: "",
            description: "",
            cohort_list: [],
            user_list: [],
            schedule_time: null,
            deep_link_type: "",
            deep_link_uuid: "",
            promotion_uuid: "",
            flyer_uuid: "",
        });
        setNotificationDraft({
            subject: "",
            description: "",
            cohort_list: [],
            user_list: [],
            schedule_time: null,
            deep_link_type: "",
            deep_link_uuid: "",
            promotion_uuid: "",
            flyer_uuid: "",
        });
    };

    useEffect(() => {
        setSelectedstore(null);
        setNotificationDraft({
            ...notificationDraft,
            deep_link_uuid: "",
        });
    }, [notificationDraft.deep_link_type]);

    const saveNotification = () => {
        notificationDraft.uuid
            ? updateNotificationApi({
                  requestData: {
                      ...notificationDraft,
                      notification_uuid: notificationDraft.uuid,
                  },
                  resCallback: () => {},
                  res200Callback: () => {
                      message.success("Notification created!");
                      fetchNotificationList(activeKey);
                      setNotificationDetailsModal(false);
                  },
              })
            : createNotificationApi({
                  requestData: { ...notificationDraft },
                  resCallback: () => {},
                  res200Callback: () => {
                      message.success("Notification created!");
                      setNotificationDetailsModal(false);
                  },
              });
    };

    const fetchNotificationList = (key) => {
        fetchNotificationListApi({
            requestData: {
                status: key,
                page: key === "queued" ? queueList.pageNum : sendList.pageNum,
            },
            resCallback: () => {
                loading && setLoading(false);
                setTableLoading(false);
            },
            res200Callback: (res) => {
                let notificationlist = res.data.notification_list;
                key === "queued"
                    ? setQueueList({
                          ...queueList,
                          notificationlist: notificationlist,
                          totalPages: res.data.total_pages,
                          total_queue: res.data.in_queue,
                      })
                    : setSendList({
                          ...sendList,
                          notificationlist: notificationlist,
                          totalPages: res.data.total_pages,
                          total_sent: res.data.sent,
                      });
                // setQueueList({...queueList,total_queue:res.data.in_queue});
                // setSendList({...sendList,total_sent:res.data.sent})
            },
        });
    };

    useEffect(() => {
        setActiveKey("queued");
    }, []);

    useEffect(() => {
        fetchNotificationList(activeKey);
    }, [queueList.pageNum, sendList.pageNum, notificationDetailsModal, activeKey]);

    useEffect(() => {
        fetchCohortAdminListApi({
            requestData: {},
            resCallback: () => {},
            res200Callback: (res) => {
                setCohortList(res.data.cohort_list);
            },
        });
        fetchPromotionListApi({
            requestData: {},
            resCallback: () => {},
            res200Callback: (res) => {
                setPromotionList(res.data.promotion_list);
            },
        });
        fetchFlyerListApi({
            requestData: {},
            resCallback: () => {},
            res200Callback: (res) => {
                setFlyerList(res.data.flyer_list);
            },
        });
        fetchAllStoresApi({
            requestData: {},
            resCallback: () => {},
            res200Callback: (res) => {
                setStoreList(res.data.store_list);
            },
        });
    }, []);

    const columns = [
        {
            title: "Notification Title",
            dataIndex: "subject",
            key: "notificationTitle",
            render: (data) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "bold",
                        fontSize: "16px",
                        lineHeight: "24px",
                        color: "#181818",
                        display: "inline-block",
                        width: "200px",
                    }}>
                    {data ? data : "-"}
                </Text>
            ),
        },
        {
            title: "Notification Date",
            dataIndex: "schedule_time",
            key: "notificationDate",
            render: (date) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#747474",
                        whiteSpace: "nowrap",
                    }}>
                    {date ? moment(date).format("DD/MM/YYYY") : "-"}
                </Text>
            ),
        },
        {
            title: "Time",
            dataIndex: "schedule_time",
            key: "notificationTime",
            render: (date) => (
                <Text
                    style={{
                        fontStyle: "normal",
                        fontWeight: "normal",
                        fontSize: "14px",
                        lineHeight: "22px",
                        color: "#747474",
                        whiteSpace: "nowrap",
                    }}>
                    {date ? moment.parseZone(date).format("hh:mm A") : "-"}
                </Text>
            ),
        },
        {
            title: "Cohort / Users",
            dataIndex: ["cohort_list", "user_list"],
            key: "reportUrl",
            render: (_, row) => (
                <>
                    {row.cohort_list.length > 0 &&
                        row.cohort_list.slice(0, 2).map((cohort) => (
                            <Text
                                key={cohort.uuid}
                                style={{
                                    padding: "1px 8px 1px 8px",
                                    backgroundColor: "#EAF4EC",
                                    color: "#fec708",
                                    fontSize: "12px",
                                    marginRight: "12px",
                                }}>
                                {cohort.name}
                            </Text>
                        ))}
                    {row.user_list.length > 0 &&
                        (row.cohort_list.length === 0
                            ? row.user_list.slice(0, 2).map((user) => (
                                  <Text
                                      key={user}
                                      style={{
                                          padding: "1px 8px 1px 8px",
                                          backgroundColor: "#EAF4EC",
                                          color: "#fec708",
                                          fontSize: "12px",
                                          marginRight: "12px",
                                      }}>
                                      {user}
                                  </Text>
                              ))
                            : row.cohort_list.length === 1 && (
                                  <Text
                                      style={{
                                          padding: "1px 8px 1px 8px",
                                          backgroundColor: "#EAF4EC",
                                          color: "#fec708",
                                          fontSize: "12px",
                                          marginRight: "12px",
                                      }}>
                                      {row.user_list[0]}
                                  </Text>
                              ))}
                    {row.cohort_list.length + row.user_list.length > 2 && (
                        <Tooltip
                            placement={"bottom"}
                            title={
                                row.cohort_list.length >= 2 ? (
                                    <>
                                        {row.cohort_list.slice(2).map((cohort) => (
                                            <Text
                                                key={cohort.uuid}
                                                style={{
                                                    padding: "1px 8px 1px 8px",
                                                    backgroundColor: "#EAF4EC",
                                                    color: "#fec708",
                                                    fontSize: "12px",
                                                    marginRight: "12px",
                                                }}>
                                                {cohort.name}
                                            </Text>
                                        ))}{" "}
                                        {row.user_list.length > 0 &&
                                            row.user_list.map((user) => (
                                                <Text
                                                    key={user}
                                                    style={{
                                                        padding: "1px 8px 1px 8px",
                                                        backgroundColor: "#EAF4EC",
                                                        color: "#fec708",
                                                        fontSize: "12px",
                                                        marginRight: "12px",
                                                    }}>
                                                    {user}
                                                </Text>
                                            ))}
                                    </>
                                ) : row.cohort_list.length === 1 && row.user_list.length > 1 ? (
                                    row.user_list.slice(1).map((user) => (
                                        <Text
                                            key={user}
                                            style={{
                                                padding: "1px 8px 1px 8px",
                                                backgroundColor: "#EAF4EC",
                                                color: "#fec708",
                                                fontSize: "12px",
                                                marginRight: "12px",
                                            }}>
                                            {user}
                                        </Text>
                                    ))
                                ) : (
                                    row.user_list.map((user) => (
                                        <Text
                                            key={user}
                                            style={{
                                                padding: "1px 8px 1px 8px",
                                                backgroundColor: "#EAF4EC",
                                                color: "#fec708",
                                                fontSize: "12px",
                                                marginRight: "12px",
                                            }}>
                                            {user}
                                        </Text>
                                    ))
                                )
                            }>
                            {row.cohort_list.length + row.user_list.length - 2 > 0 && (
                                <Text
                                    style={{
                                        color: "#fec708",
                                        whiteSpace: "nowrap",
                                        fontSize: 12,
                                    }}>{`+${row.cohort_list.length + row.user_list.length - 2} More`}</Text>
                            )}
                        </Tooltip>
                    )}
                </>
            ),
        },
        {
            title: "Sent To",
            dataIndex: "sent_count",
            key: "sentTo",
        },
        {
            title: "Redirect To",
            dataIndex: ["deep_link_type", "destination_page"],
            key: "redirectTo",
            render: (_, row) => (
                <Row type='flex' style={{ flexDirection: "column" }}>
                    <Text
                        style={{
                            fontStyle: "normal",
                            fontWeight: "bold",
                            fontSize: "16px",
                            lineHeight: "24px",
                            color: "#181818",
                            whiteSpace: "nowrap",
                        }}>
                        {row.deep_link_type
                            ? row.deep_link_type.charAt(0).toUpperCase() + row.deep_link_type.slice(1) + " Page"
                            : "-"}
                    </Text>
                    {row.destination_page && (
                        <Text
                            style={{
                                fontStyle: "normal",
                                fontSize: "14px",
                                lineHeight: "24px",
                                maxWidth: 250,
                                whiteSpace: "nowrap",
                                textOverflow: "ellipsis",
                                overflow: "hidden",
                            }}>
                            {row.destination_page}
                        </Text>
                    )}
                </Row>
            ),
        },
        {
            title: "",
            dataIndex: "uuid",
            key: "actions",
            render: (uuid, data) => (
                <span>
                    {activeKey !== "sent" ? (
                        <Dropdown
                            placement={"bottomLeft"}
                            overlay={
                                <Menu>
                                    <Menu.Item
                                        onClick={() => {
                                            setNotificationDetail({ ...data });
                                            setNotificationDraft({ ...data });
                                            setNotificationDetailsModal(true);
                                        }}>
                                        <Text style={{ color: "#181818" }}>Edit</Text>
                                    </Menu.Item>
                                    <Menu.Item
                                        onClick={(e) => {
                                            e.domEvent.stopPropagation();
                                            deleteNotification.current = uuid;
                                            setDeleteModal(true);
                                        }}>
                                        <Text style={{ color: "#F5222D" }}>Delete</Text>
                                    </Menu.Item>
                                </Menu>
                            }>
                            <Icon
                                type='more'
                                onClick={(e) => {
                                    e.stopPropagation();
                                }}
                                style={{
                                    
                                    color: "#747474",
                                    marginLeft: "52px",
                                }}
                            />
                        </Dropdown>
                    ) : (
                        <Icon
                            type='delete'
                            style={{ color: "red",fontSize: "18px" , opacity:"0.6" }}
                            onClick={(e) => {
                                e.stopPropagation();
                                setNotificationDetailsModal(false);
                                deleteNotification.current = uuid;
                                setDeleteModal(true);
                            }}
                        />
                    )}
                </span>
            ),
        },
    ];

    return (
        <>
            {loading ? (
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#FAFAFA",
                    }}>
                    <Loader />
                </div>
            ) : queueList.notificationlist.length + sendList.notificationlist.length === 0 &&
              (queueList.total_pages === sendList.total_pages) === 1 ? (
                <div
                    style={{
                        minHeight: "100vh",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#FAFAFA",
                        paddingTop: 100,
                    }}>
                    <img src={emptyImage} style={{ marginTop: "-127px" }} />
                    <Text
                        style={{
                            fontSize: "20px",
                            color: "#181818",
                            fontWeight: "bold",
                            marginTop: "16px",
                        }}>
                        You have not created any notifications yet.
                    </Text>
                    <Text style={{ color: "#747474", marginTop: "8px" }}>
                        Click on Create Notification to add a new notification
                    </Text>
                    <Button
                        size={"large"}
                        onClick={() => {
                            clearNotificationDetail();
                            setNotificationDetailsModal(true);
                            // setCreateStatus(true);
                            // setNotificationUuid("");
                            // setActiveIndex(-1);
                            // clearNotificationData();
                        }}
                        style={{
                            marginTop: "24px",
                            backgroundColor: "#fec708",
                            color: "#FFFFFF",
                            border: "none",
                            borderRadius: "5px",
                        }}>
                        Create Notification
                    </Button>
                </div>
            ) : (
                <>
                    <Row
                        style={{
                            width: "100%",
                            padding: "40px 25px 0",
                            margin: "60px auto 20px",
                            backgroundColor: "#FAFAFA",
                        }}
                        gutter={[12, 48]}>
                        <Row className='buttons' type='flex' justify='space-between' align='middle'>
                            <Text
                                style={{
                                    marginBottom: "0px",
                                    color: "#000000",
                                    fontSize: "24px",
                                    fontWeight: 700,
                                    cursor: "default",
                                }}>
                                Notification Center
                            </Text>

                            <Button
                                size='large'
                                onClick={(e) => {
                                    clearNotificationDetail();
                                    setNotificationDetailsModal(true);
                                    // setCreateStatus(true);
                                    // setNotificationUuid("");
                                    // setActiveIndex(-1);
                                    // clearNotificationData();
                                }}
                                style={{
                                    backgroundColor: "#fec708",
                                    color: "#FFFFFF",
                                    border: "none",
                                    borderRadius: "5px",
                                }}>
                                Create Notification
                            </Button>
                        </Row>
                        <Tabs
                            defaultActiveKey='queued'
                            onChange={(key) => {
                                setActiveKey(key);
                            }}>
                            <TabPane tab={`In Queue (${queueList.total_queue})`} key='queued'>
                                {queueList.notificationlist.length === 0 ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            backgroundColor: "#FAFAFA",
                                        }}>
                                        <img src={emptyImage} />
                                        <Text
                                            style={{
                                                fontSize: "20px",
                                                color: "#181818",
                                                fontWeight: "bold",
                                                marginTop: "16px",
                                            }}>
                                            You have no notifications in queue
                                        </Text>
                                        <Text
                                            style={{
                                                color: "#747474",
                                                marginTop: "8px",
                                            }}>
                                            Click on Create Notification to add a new notification
                                        </Text>
                                    </div>
                                ) : (
                                    <Table
                                        columns={columns}
                                        dataSource={queueList.notificationlist}
                                        pagination={{
                                            showQuickJumper: true,
                                            current: queueList.pageNum,
                                            total: queueList.pageSize * queueList.totalPages,
                                            pageSize: queueList.pageSize,
                                        }}
                                        loading={tableLoading}
                                        style={{ marginTop: "-10px" }}
                                        onChange={(pagination) =>
                                            setQueueList({ ...queueList, pageNum: pagination.current })
                                        }
                                        onRow={(data) => ({
                                            onClick: () => {
                                                clearNotificationDetail();
                                                setNotificationDetail({
                                                    ...data,
                                                });
                                                setNotificationDraft({
                                                    ...data,
                                                });
                                                setNotificationDetailsModal(true);
                                            },
                                        })}
                                    />
                                )}
                            </TabPane>
                            <TabPane tab={`Sent (${sendList.total_sent})`} key='sent'>
                                {sendList.notificationlist.length === 0 ? (
                                    <div
                                        style={{
                                            display: "flex",
                                            flexDirection: "column",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            backgroundColor: "#FAFAFA",
                                        }}>
                                        <img src={emptyImage} />
                                        <Text
                                            style={{
                                                fontSize: "20px",
                                                color: "#181818",
                                                fontWeight: "bold",
                                                marginTop: "16px",
                                            }}>
                                            You have not sent any notifications yet
                                        </Text>
                                        <Text
                                            style={{
                                                color: "#747474",
                                                marginTop: "8px",
                                            }}>
                                            Click on Create Notification to add a new notification
                                        </Text>
                                    </div>
                                ) : (
                                    <Table
                                        columns={columns}
                                        dataSource={sendList.notificationlist}
                                        pagination={{
                                            showQuickJumper: true,
                                            current: sendList.pageNum,
                                            total: sendList.pageSize * sendList.totalPages,
                                            pageSize: sendList.pageSize,
                                        }}
                                        loading={tableLoading}
                                        style={{ marginTop: "-10px" }}
                                        onChange={(pagination) =>
                                            setSendList({ ...sendList, pageNum: pagination.current })
                                        }
                                        onRow={(data) => ({
                                            onClick: () => {
                                                clearNotificationDetail();
                                                setNotificationDetail({
                                                    ...data,
                                                });
                                                setNotificationDraft({
                                                    ...data,
                                                });
                                                setNotificationDetailsModal(true);
                                            },
                                        })}
                                    />
                                )}
                            </TabPane>
                        </Tabs>
                    </Row>

                    <Modal
                        footer={null}
                        title={null}
                        visible={discardModal}
                        destroyOnClose={true}
                        maskClosable={false}
                        onCancel={() => setDiscardModal(false)}
                        style={{
                            backgroundColor: "#fff",
                            borderRadius: "10px",
                            boxShadow: "0px 10px 30px rgba(24, 24, 24, 0.2)",
                        }}>
                        <Row className={"modal-row"}>
                            <Row>
                                <Icon
                                    type='edit'
                                    style={{
                                        color: "#181818",
                                        fontSize: "24px",
                                        marginRight: "16px",
                                    }}
                                />
                                <Text
                                    style={{
                                        fontWeight: "bold",
                                        color: "#181818",
                                        fontSize: "24px",
                                    }}>
                                    Discard draft
                                </Text>
                            </Row>
                            <Row style={{ marginTop: "24px" }}>
                                <Col span={24}>
                                    <Text>
                                        You haven’t saved the Notification yet. Are you sure you want to leave and
                                        discard your draft?
                                    </Text>
                                </Col>
                                <Col
                                    style={{
                                        marginTop: "60px",
                                        textAlign: "right",
                                    }}
                                    span={18}>
                                    <Button
                                        size='large'
                                        style={{
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "1px solid #fec708",
                                            backgroundColor: "#FFFFFF",
                                            color: "#fec708",
                                        }}
                                        onClick={() => setDiscardModal(false)}>
                                        Go Back
                                    </Button>
                                </Col>
                                <Col
                                    style={{
                                        marginTop: "60px",
                                        textAlign: "right",
                                    }}
                                    span={6}>
                                    <Button
                                        size='large'
                                        style={{
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: "#fec708",
                                            color: "#FFFFFF",
                                        }}
                                        onClick={() => {
                                            setDiscardModal(false);
                                            setNotificationDetailsModal(false);
                                        }}>
                                        Discard
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    </Modal>

                    <Modal
                        centered
                        visible={deleteModal}
                        destroyOnClose
                        maskClosable={false}
                        onCancel={() => setDeleteModal(false)}
                        footer={null}>
                        <Row className='modal-row'>
                            <Row>
                                <Icon
                                    type='delete'
                                    style={{
                                        color: "#181818",
                                        fontSize: "24px",
                                        marginRight: "16px",
                                    }}
                                />
                                <Text
                                    style={{
                                        fontWeight: "bold",
                                        color: "#181818",
                                        fontSize: "24px",
                                    }}>
                                    Delete item
                                </Text>
                            </Row>
                            <Row style={{ marginTop: "24px" }}>
                                <Col span={24}>
                                    <Text>Are you sure you want to delete this item?</Text>
                                </Col>
                                <Col
                                    style={{
                                        marginTop: "60px",
                                        textAlign: "right",
                                    }}
                                    span={18}>
                                    <Button
                                        size='large'
                                        style={{
                                            height: "40px",
                                            boxShadow: "none",
                                            borderRadius: "20px",
                                            border: "none",
                                            backgroundColor: "#FFFFFF",
                                            color: "#181818",
                                        }}
                                        onClick={() => setDeleteModal(false)}>
                                        Cancel
                                    </Button>
                                </Col>
                                <Col
                                    style={{
                                        marginTop: "60px",
                                        textAlign: "right",
                                    }}
                                    span={6}>
                                    <Button
                                        size='large'
                                        style={{
                                            height: "40px",
                                            borderRadius: "5px",
                                            border: "none",
                                            backgroundColor: "#C91713",
                                            color: "#FFFFFF",
                                        }}
                                        onClick={() => {
                                            deleteNotificationApi({
                                                requestData: {
                                                    notification_uuid: deleteNotification.current,
                                                },
                                                res200Callback: () => {
                                                    fetchNotificationList(activeKey);
                                                    setNotificationDetailsModal(false);
                                                    setDeleteModal(false);
                                                },
                                            });
                                        }}>
                                        Delete
                                    </Button>
                                </Col>
                            </Row>
                        </Row>
                    </Modal>
                </>
            )}
            <Modal
                visible={notificationDetailsModal}
                destroyOnClose
                maskClosable={false}
                onCancel={() => {
                    if (activeKey === "sent") {
                        setNotificationDetailsModal(false);
                    } else {
                        deepEqual(notificationDetail, notificationDraft)
                            ? setNotificationDetailsModal(false)
                            : setDiscardModal(true);
                    }
                }}
                footer={null}
                width={"70vw"}>
                <Row className='modal-row' style={{ display: "flex", flexDirection: "column" }}>
                    <Row>
                        <Icon
                            type='bell'
                            style={{
                                color: "#181818",
                                fontSize: "24px",
                                marginRight: "16px",
                            }}
                        />
                        <Text
                            style={{
                                fontWeight: "bold",
                                color: "#181818",
                                fontSize: "24px",
                            }}>
                            {notificationDraft.uuid ? "View Notification" : "Create New Notification"}
                        </Text>
                    </Row>
                    <Row style={{ marginTop: "24px", flexGrow: "1" }}>
                        <Col span={14} style={{ paddingRight: "20px" }}>
                            <Col
                                span={24}
                                style={{
                                    border: "1px solid #E8E8E8",
                                    borderRadius: "10px",
                                    padding: "20px",
                                }}>
                                <Col span={24}>
                                    <Row type={"flex"} justify={"space-between"}>
                                        <Text
                                            style={{
                                                fontSize: "14px",
                                                color: "#181818",
                                            }}>
                                            Notification Title
                                        </Text>
                                        <Text
                                            style={{
                                                fontSize: "12px",
                                                color: "#747474",
                                            }}>
                                            {notificationDraft.subject?.length}
                                            /100
                                        </Text>
                                    </Row>
                                    <Row>
                                        <Input
                                            style={{
                                                backgroundColor: "#FFFFFF",
                                                border: "1px solid #D9D9D9",
                                                borderRadius: "5px",
                                                marginTop: "8px",
                                            }}
                                            disabled={notificationDraft.uuid && activeKey === "sent" ? true : false}
                                            value={notificationDraft.subject}
                                            onChange={(e) => {
                                                setNotificationDraft({
                                                    ...notificationDraft,
                                                    subject: e.target.value,
                                                });
                                            }}
                                            placeholder={"Eg. - Mid Week deals are going on"}
                                            maxLength={100}
                                        />
                                    </Row>
                                </Col>
                                <Col span={24} style={{ marginTop: "24px" }}>
                                    <Row type={"flex"} justify={"space-between"}>
                                        <Text
                                            style={{
                                                fontSize: "14px",
                                                color: "#181818",
                                            }}>
                                            Notification Description
                                        </Text>
                                        <Text
                                            style={{
                                                fontSize: "12px",
                                                color: "#747474",
                                            }}>
                                            {notificationDraft.description?.length}
                                            /178
                                        </Text>
                                    </Row>
                                    <Row>
                                        <Col span={24} style={{ marginRight: "0px" }}>
                                            <Input.TextArea
                                                maxLength={178}
                                                style={{ height: "166px", marginTop: "10px" }}
                                                disabled={notificationDraft.uuid && activeKey === "sent" ? true : false}
                                                value={notificationDraft.description}
                                                placeholder={"Enter Description"}
                                                className={"time-value-cohort-col-main-element "}
                                                onChange={(e) => {
                                                    setNotificationDraft({
                                                        ...notificationDraft,
                                                        description: e.target.value,
                                                    });
                                                    console.log("Des ;-", e.target.value);
                                                    // console.log("Code : ",e.charCodeAt(111))
                                                    console.log("Code : ", e.target.value.charAt(0));
                                                }}
                                            />
                                        </Col>
                                        {/* <Col span={24} style={{ marginRight: "0px" }}>
                                            <EditorBox
                                                // className='quill-editor-borderless quill-editor-toolbar-style'
                                                maxLength={178}
                                                notification={true}
                                                value={notificationDraft.description}
                                                getText={(e) => {
                                                    setNotificationDraft({
                                                        ...notificationDraft,
                                                        description: e,
                                                    });
                                                    console.log("description :- ", e);
                                                    // console.log("Code : ",e.charCodeAt(111))
                                                    console.log("Code : ", e.charAt(111));
                                                }}
                                                placeholder={"Write Notification Description"}
                                                height='166px'
                                                style={{
                                                    display: "flex",
                                                    flexDirection: "column",
                                                    marginTop: "10px",
                                                    fontSize: "14px",
                                                }}
                                            />
                                        </Col> */}
                                    </Row>
                                </Col>
                            </Col>
                        </Col>
                        <Col
                            span={10}
                            style={{
                                border: "1px solid #E8E8E8",
                                borderRadius: "10px",
                            }}>
                            <Col
                                span={24}
                                style={{
                                    padding: "20px",
                                    // borderBottom: '1px solid #E8E8E8'
                                }}>
                                <Col span={24}>
                                    <Text
                                        style={{
                                            fontSize: "16px",
                                            color: "#181818",
                                            // fontWeight: 'bold'
                                        }}>
                                        Redirect Notification
                                    </Text>
                                </Col>
                                <Col span={24} style={{ marginTop: "12px" }}>
                                    <Text
                                        style={{
                                            fontSize: "14px",
                                            color: "#181818",
                                            // fontWeight: 'bold'
                                        }}>
                                        Page Type
                                    </Text>
                                    <Select
                                        className={"time-value-cohort-col-main-element"}
                                        value={notificationDraft.deep_link_type || "default"}
                                        style={{
                                            width: "100%",
                                            marginTop: "8px",
                                        }}
                                        disabled={notificationDraft.uuid && activeKey === "sent" ? true : false}
                                        placeholder='Select Destination from dropdown'
                                        onChange={(value) => {
                                            setNotificationDraft({
                                                ...notificationDraft,
                                                deep_link_type: value,
                                            });
                                        }}>
                                        <Option value='default'>Select Destination</Option>
                                        <Option value='promotion'>Promotion Page</Option>
                                        <Option value='profile'>Profile Page</Option>
                                        <Option value='flyer'>Flyer Page</Option>
                                        <Option value='home'>Home Page</Option>
                                        <Option value='feedback'>Feedback Page</Option>
                                    </Select>
                                </Col>
                                <Col span={24} style={{ marginTop: "20px" }}>
                                    <Text
                                        style={{
                                            fontSize: "14px",
                                            color: "#181818",
                                        }}>
                                        Stores
                                    </Text>
                                    <Select
                                        className={"time-value-cohort-col-main-element"}
                                        showSearch
                                        value={selectedstore || "default"}
                                        disabled={
                                            notificationDraft.deep_link_type !== "flyer" ||
                                            (notificationDraft.uuid && activeKey === "sent")
                                                ? true
                                                : false
                                        }
                                        onChange={(item) => {
                                            setSelectedstore(item === "default" ? "" : item);
                                            setNotificationDraft({
                                                ...notificationDraft,
                                                cohort_list:
                                                    item === "default"
                                                        ? []
                                                        : [storeList.find((store) => store.uuid === item)?.cohort],
                                            });
                                        }}
                                        style={{
                                            width: "100%",
                                            marginTop: "12px",
                                            //border: "1px solid rgba(109, 109, 109, 0.54)"
                                        }}
                                        optionFilterProp={"label"}
                                        placeholder='Select Store'>
                                        <Option value='default'>Select Stores</Option>
                                        {notificationDraft.deep_link_type === "flyer" &&
                                            storeList
                                                ?.filter((item) => item.is_enabled)
                                                ?.map((item) => (
                                                    <Option
                                                        value={item.uuid}
                                                        key={item.uuid}
                                                        label={`${item.name} ${item.sap_code} ${item.company_code}`}>
                                                        {`${item.name} ( ${item.sap_code} )`}
                                                    </Option>
                                                ))}
                                    </Select>
                                </Col>
                                <Col span={24} style={{ marginTop: "20px" }}>
                                    <Text
                                        style={{
                                            fontSize: "14px",
                                            color: "#181818",
                                        }}>
                                        Destination Page
                                    </Text>
                                    <Select
                                        className={"time-value-cohort-col-main-element"}
                                        showSearch
                                        value={
                                            notificationDraft.deep_link_uuid === ""
                                                ? undefined
                                                : notificationDraft.deep_link_uuid
                                        }
                                        optionLabelProp={"label"}
                                        disabled={
                                            (notificationDraft.deep_link_type !== "promotion" &&
                                                notificationDraft.deep_link_type !== "flyer") ||
                                            (notificationDraft.uuid && activeKey === "sent")
                                                ? true
                                                : false
                                        }
                                        onChange={(uuid) =>
                                            setNotificationDraft({
                                                ...notificationDraft,
                                                deep_link_uuid: uuid === "default" ? "" : uuid,
                                            })
                                        }
                                        optionFilterProp={"label"}
                                        style={{
                                            width: "100%",
                                            marginTop: "12px",
                                            //border: "1px solid rgba(109, 109, 109, 0.54)"
                                        }}
                                        placeholder='Search Destination'>
                                        <Option value='default'>Select Destination</Option>
                                        {notificationDraft.deep_link_type === "promotion"
                                            ? promotionList?.map((page) => (
                                                  <Option value={page.uuid} key={page.uuid} label={page.title}>
                                                      <DestinationOption item={{ ...page, list: page.cohort_list }} />
                                                  </Option>
                                              ))
                                            : notificationDraft.deep_link_type === "flyer"
                                            ? flyerList?.map((page) => (
                                                  <Option value={page.uuid} key={page.uuid} label={page.title}>
                                                      <DestinationOption item={{ ...page, list: page.stores }} />
                                                  </Option>
                                              ))
                                            : null}
                                    </Select>
                                </Col>
                            </Col>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "24px", flexGrow: "1" }}>
                        <Col span={17} style={{ paddingRight: "20px" }}>
                            <Col
                                span={24}
                                style={{
                                    border: "1px solid #E8E8E8",
                                    borderRadius: "10px",
                                    padding: "20px",
                                }}>
                                <Col span={24}>
                                    <Text
                                        style={{
                                            fontSize: "16px",
                                            color: "#181818",
                                            // fontWeight: 'bold'
                                        }}>
                                        Select Cohort / Users
                                    </Text>
                                </Col>
                                <Col span={24}>
                                    <Row>
                                        <Col
                                            span={15}
                                            style={{
                                                marginTop: "12px",
                                                paddingRight: "20px",
                                            }}>
                                            <Text
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#181818",
                                                    // fontWeight: 'bold'
                                                }}>
                                                Select Cohort
                                            </Text>

                                            <Select
                                                mode='multiple'
                                                style={{
                                                    width: "100%",
                                                    marginTop: "4px",
                                                }}
                                                placeholder='Eg. - Cohort 1'
                                                className='time-value-cohort-col-main-element'
                                                value={notificationDraft.cohort_list.map((cohort) => cohort.uuid)}
                                                onChange={(e) =>
                                                    setNotificationDraft({
                                                        ...notificationDraft,
                                                        cohort_list: e.map((item) =>
                                                            cohortList.find((cohort) => cohort.uuid === item)
                                                        ),
                                                    })
                                                }
                                                disabled={
                                                    selectedstore || (notificationDraft.uuid && activeKey === "sent")
                                                        ? true
                                                        : false
                                                }
                                                optionLabelProp='label'>
                                                {cohortList?.map((cohortItem) => (
                                                    <Option
                                                        value={cohortItem.uuid}
                                                        key={cohortItem.uuid}
                                                        label={cohortItem.name}>
                                                        {cohortItem.name}
                                                    </Option>
                                                ))}
                                            </Select>
                                        </Col>
                                        <Col span={9} style={{ marginTop: "12px" }}>
                                            <Text
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#181818",
                                                    // fontWeight: 'bold'
                                                }}>
                                                Add Customer Phone Number
                                            </Text>

                                            <Select
                                                mode='tags'
                                                className='time-value-cohort-col-main-element'
                                                style={{
                                                    width: "100%",
                                                    marginTop: "4px",
                                                    overflow: "hidden",
                                                }}
                                                placeholder='Eg. - 552980118'
                                                value={notificationDraft.user_list}
                                                tokenSeparators={[",", " "]}
                                                //disabled={selectedstore}
                                                disabled={notificationDraft.uuid && activeKey === "sent" ? true : false}
                                                onChange={(e) => {
                                                    if (
                                                        (e[e.length - 1]?.match("^[0-9]+$") &&
                                                            e[e.length - 1]?.length ===
                                                                JSON.parse(localStorage.getItem("countryData"))
                                                                    .contact_number_length +
                                                                    JSON.parse(localStorage.getItem("countryData"))
                                                                        .isd_code.length) ||
                                                        e.length === 0
                                                    ) {
                                                        setNotificationDraft({
                                                            ...notificationDraft,
                                                            user_list: e,
                                                        });
                                                    } else {
                                                        message.error("Please enter valid contact number");
                                                    }
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                            </Col>
                        </Col>
                        <Col
                            span={7}
                            style={{
                                border: "1px solid #E8E8E8",
                                borderRadius: "10px",
                            }}>
                            <Col
                                span={24}
                                style={{
                                    padding: "20px",
                                    // borderBottom: '1px solid #E8E8E8'
                                }}>
                                <Col span={24}>
                                    <Text
                                        style={{
                                            fontSize: "16px",
                                            color: "#181818",
                                            // fontWeight: 'bold'
                                        }}>
                                        Notification Schedule
                                    </Text>
                                </Col>
                                <Col span={24} style={{ marginTop: "12px" }}>
                                    <Text
                                        style={{
                                            fontSize: "14px",
                                            color: "#181818",
                                            // fontWeight: 'bold'
                                        }}>
                                        Date and Time
                                    </Text>
                                    <br />
                                    <DatePicker
                                        value={
                                            notificationDraft.schedule_time
                                                ? moment(notificationDraft.schedule_time, "YYYY-MM-DD HH:mm:ss")
                                                : null
                                        }
                                        className='time-value-cohort-col-main-element'
                                        showTime
                                        placeholder='Select Date & Time'
                                        style={{ borderRadius: "5px" }}
                                        disabled={notificationDraft.uuid && activeKey === "sent" ? true : false}
                                        onChange={(_, dateString) =>{
                                            setNotificationDraft({
                                                ...notificationDraft,
                                                schedule_time: dateString.replace(" ", "T").concat("Z"),
                                            })}
                                        }
                                    />
                                </Col>
                            </Col>
                        </Col>
                    </Row>
                    <Row style={{ marginTop: "40px" }}>
                        <Col span={24} style={{ textAlign: "right" }}>
                            <Row
                                type='flex'
                                justify='space-between'
                                align='middle'
                                style={{ flexDirection: "row-reverse" }}>
                                {!(activeKey === "sent" && notificationDraft.uuid) && (
                                    <Button
                                        visible={"false"}
                                        onClick={() => {
                                            if (
                                                (notificationDraft.cohort_list.length === 0 &&
                                                    notificationDraft.user_list.length === 0) ||
                                                notificationDraft.schedule_time === "" ||
                                                notificationDraft.subject === "" ||
                                                (notificationDraft.deep_link_type === "promotion" &&
                                                    notificationDraft.deep_link_uuid === "") ||
                                                (notificationDraft.deep_link_type === "flyer" &&
                                                    notificationDraft.deep_link_uuid === "")
                                            ) {
                                                message.info("Please fill out the details");
                                            } else {
                                                saveNotification();
                                            }
                                        }}
                                        size={"large"}
                                        style={{
                                            backgroundColor: "#fec708",
                                            color: "#FFFFFF",
                                            border: "none",
                                            borderRadius: "5px",
                                        }}>
                                        {notificationDraft.uuid ? "Save & Update" : "Create Notification"}
                                    </Button>
                                )}
                                {notificationDraft.uuid && (
                                    <Button
                                        onClick={() => {
                                            deleteNotification.current = notificationDraft.uuid;
                                            setDeleteModal(true);
                                        }}
                                        size={"large"}
                                        style={{
                                            backgroundColor: "#FFFFFF",
                                            border: "1px solid #F5222D",
                                            color: "#F5222D",
                                            borderRadius: "5px",
                                        }}>
                                        Delete
                                    </Button>
                                )}
                            </Row>
                        </Col>
                    </Row>
                </Row>
            </Modal>
        </>
    );
};

export default NotificationCenter;
